import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getNotificationDetailRequest,
    getNotificationsRequest,
    IRejectWithValue,
    MobileNotification,
    MobileNotificationDetail,
    PhpClientPaginatedResponse,
    PhpResponse,
    PhpResponsePaginated,
} from "../../../types";
import { phpClient } from "../../../network";

export const getNotifications = createAsyncThunk<
    PhpClientPaginatedResponse<MobileNotification>,
    getNotificationsRequest,
    IRejectWithValue
>("mobile/getNotifications", async (data, { rejectWithValue }) => {
    try {
        const response = await phpClient.post<PhpClientPaginatedResponse<MobileNotification>>({
            url: "/notification",
            data,
        });

        return response;
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});

export const getNotificationDetail = createAsyncThunk<
    MobileNotificationDetail | undefined,
    getNotificationDetailRequest,
    IRejectWithValue
>("mobile/getNotificationDetails", async (data, { rejectWithValue }) => {
    const { notificationId } = data;
    try {
        const response = await phpClient.post<PhpResponse<MobileNotificationDetail>>({
            url: `/notification/details/${notificationId}`,
            data: {
                notification_id: notificationId,
                read_status: 1,
            },
        });

        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});
